<template>
    <div class="notice-print">
        <el-card>
            <div slot="header">
                <h3>通知书打印</h3>
            </div>
            
            <div class="filter-section">
                <el-form :inline="true" :model="filterForm" class="filter-form">
                    
                    <el-form-item label="模板">
                        <el-select v-model="filterForm.templateId" placeholder="请选择模板" style="width: 200px">
                            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学院">
                        <el-select v-model="filterForm.college" placeholder="请选择学院" style="width: 200px">
                            <el-option v-for="item in collegeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="专业">
                        <el-select v-model="filterForm.major" placeholder="请选择专业" style="width: 200px">
                            <el-option v-for="item in majorList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="批次">
                        <el-select v-model="filterForm.batch" placeholder="请选择批次" style="width: 200px">
                            <el-option v-for="item in batchList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchStudents">查询</el-button>
                        <el-button @click="resetFilter">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            
            <div class="action-bar">
                <span>共 {{ total }} 条记录</span>
                <div class="action-buttons">
                    <el-button type="primary" @click="selectAll">全选</el-button>
                    <el-button @click="selectNone">取消全选</el-button>
                    <el-button type="success" @click="generateNotices" :disabled="selectedIds.length === 0">
                        <i class="el-icon-printer"></i> 批量生成通知书
                    </el-button>
                    <el-button type="warning" @click="downloadNotices" :disabled="selectedIds.length === 0">
                        <i class="el-icon-download"></i> 下载通知书
                    </el-button>
                </div>
            </div>
            
            <div class="student-table">
                <el-table
                    :data="studentList"
                    :height="tableHeight"
                    border
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="KSH" label="考生号" width="150"></el-table-column>
                    <el-table-column prop="XM" label="姓名" width="100"></el-table-column>
                    <el-table-column prop="ZJHM" label="身份证号" width="180"></el-table-column>
                    <el-table-column prop="G_XYMC" label="学院" width="150"></el-table-column>
                    <el-table-column prop="LQZYMC" label="专业" width="200"></el-table-column>
                    <el-table-column prop="PCMC" label="批次" width="120"></el-table-column>
                    <el-table-column prop="BH" label="编号" width="150" :formatter="formatBH"></el-table-column>
                    <el-table-column prop="NOTICE_STATUS" label="通知书状态" width="120">
                        <template slot-scope="scope">
                            <el-tag :type="getNoticeStatusType(scope.row.NOTICE_STATUS)">
                                {{ getNoticeStatusText(scope.row.NOTICE_STATUS) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click="previewNotice(scope.row)">预览</el-button>
                            <el-button type="text" @click="generateSingleNotice(scope.row)">生成</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagination.size"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'NoticePrint',
        data() {
            return {
                filterForm: {
                    templateId: '',
                    college: '',
                    major: '',
                    batch: ''
                },
                collegeList: [],
                majorList: [],
                batchList: [],
                templateList: [],
                studentList: [],
                selectedIds: [],
                total: 0,
                tableHeight: 500,
                pagination: {
                    page: 1,
                    size: 20
                }
            };
        },
        mounted() {
            this.loadFilterOptions();
            this.loadTemplates();
            this.searchStudents();
            this.calculateTableHeight();
            window.addEventListener('resize', this.calculateTableHeight);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateTableHeight);
        },
        methods: {
            calculateTableHeight() {
                this.tableHeight = window.innerHeight - 420;
            },
            loadFilterOptions() {
                const api_name = '/Notice/GetFilterOptions';
                const url = TYBM_Env.GetApiUrl(api_name);
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: false, show_error: false })
                    .then(response => {
                        if (response.code === 'ok') {
                            this.collegeList = response.data.collegeList || [];
                            this.majorList = response.data.majorList || [];
                            this.batchList = response.data.batchList || [];
                        }
                    })
                    .catch(error => {
                        console.error('加载筛选选项失败', error);
                    });
            },
            loadTemplates() {
                const api_name = '/Notice/GetTemplates';
                const url = TYBM_Env.GetApiUrl(api_name);
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: false, show_error: false })
                    .then(response => {
                        if (response.code === 'ok') {
                            this.templateList = response.data || [];
                        }
                    })
                    .catch(error => {
                        console.error('加载模板列表失败', error);
                    });
            },
            searchStudents() {
                const api_name = '/Notice/GetStudentList';
                const url = TYBM_Env.GetApiUrl(api_name);
                
                const params = {
                    college: this.filterForm.college,
                    major: this.filterForm.major,
                    batch: this.filterForm.batch,
                    Page: this.pagination.page,
                    PageCount: this.pagination.size
                };
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, params, { loading: false, show_error: false })
                    .then(response => {
                        if (response.code === 'ok') {
                            this.studentList = response.data.list || [];
                            this.total = response.data.total || 0;
                        }
                    })
                    .catch(() => {
                        this.$message.error('查询失败');
                    });
            },
            resetFilter() {
                this.filterForm = {
                    templateId: '',
                    college: '',
                    major: '',
                    batch: ''
                };
                this.searchStudents();
            },
            selectAll() {
                this.$refs.table.toggleAllSelection();
            },
            selectNone() {
                this.$refs.table.clearSelection();
            },
            handleSelectionChange(val) {
                this.selectedIds = val.map(item => item.G_SN);
            },
            handleSizeChange(val) {
                this.pagination.size = val;
                this.searchStudents();
            },
            handleCurrentChange(val) {
                this.pagination.page = val;
                this.searchStudents();
            },
            formatBH(row) {
                var bh = row.BH;
                if (!bh) return '';
                var bhStr = typeof bh === 'object' ? JSON.stringify(bh) : String(bh);
                if (bhStr.indexOf('.') > 0) {
                    bhStr = bhStr.split('.')[0];
                }
                if (bhStr.length !== 10) return bhStr;
                
                var prefix = bhStr.substring(0, 2);
                var year = bhStr.substring(2, 6);
                var seq = bhStr.substring(6);
                
                var typePrefix = '';
                switch (prefix) {
                    case '11': typePrefix = 'BK'; break;
                    case '22': typePrefix = 'ZK'; break;
                    case '33': typePrefix = 'ZD'; break;
                    default: return bhStr;
                }
                return typePrefix + year + seq;
            },
            getNoticeStatusType(status) {
                switch (status) {
                    case '已生成': return 'success';
                    case '已打印': return 'info';
                    case '未生成': return 'danger';
                    default: return 'info';
                }
            },
            getNoticeStatusText(status) {
                return status || '未生成';
            },
            previewNotice(row) {
                const url = TYBM_Env.GetApiUrl('/Notice/PreviewNotice') + '?sn=' + row.G_SN;
                window.open(url, '_blank');
            },
            generateSingleNotice(row) {
                this.$confirm('确定要为该考生生成录取通知书吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const api_name = '/Notice/GenerateNotice';
                    const url = TYBM_Env.GetApiUrl(api_name);
                    
                    TYBM_Tools.AxiosPostEx(this, api_name, url, { sn: row.G_SN, templateId: this.filterForm.templateId }, { loading: false, show_error: false })
                        .then(response => {
                            if (response.code === 'ok') {
                                this.$message.success('生成成功');
                                this.searchStudents();
                            } else {
                                this.$message.error(response.errmsg || '生成失败');
                            }
                        })
                        .catch(() => {
                            this.$message.error('生成失败');
                        });
                }).catch(() => { });
            },
            generateNotices() {
                this.$confirm('确定要为选中的' + this.selectedIds.length + '名考生批量生成录取通知书吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const api_name = '/Notice/BatchGenerateNotice';
                    const url = TYBM_Env.GetApiUrl(api_name);
                    
                    TYBM_Tools.AxiosPostEx(this, api_name, url, { snList: this.selectedIds, templateId: this.filterForm.templateId }, { loading: false, show_error: false })
                        .then(response => {
                            if (response.code === 'ok') {
                                this.$message.success('批量生成成功，共生成 ' + response.data.count + ' 份通知书');
                                this.searchStudents();
                            } else {
                                this.$message.error(response.errmsg || '批量生成失败');
                            }
                        })
                        .catch(() => {
                            this.$message.error('批量生成失败');
                        });
                }).catch(() => { });
            },
            downloadNotices() {
                const url = TYBM_Env.GetApiUrl('/Notice/DownloadNotices') + '?snList=' + this.selectedIds.join(',') + '&templateId=' + this.filterForm.templateId;
                window.open(url, '_blank');
            }
        }
    };
</script>

<style scoped>
    .notice-print {
        padding: 20px;
    }

    .filter-section {
        margin-bottom: 20px;
    }

    .filter-form {
        padding: 10px;
        background: #f9fafc;
        border-radius: 8px;
    }

    .action-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 10px;
        background: #f9fafc;
        border-radius: 8px;
    }

    .action-buttons {
        display: flex;
        gap: 10px;
    }

    .student-table {
        margin-top: 20px;
    }

    .student-table .el-table {
        margin-bottom: 15px;
    }

    .student-table .el-pagination {
        text-align: right;
    }
</style>